import PageMain from '../../components/Navigation/PageMain/PageMain';
import ContactStatusSettings from '../../components/Settings/ContactStatusSettings/ContactStatusSettings';
import { useUserContactStatuses } from '../../sic-lib/api/hooks/useUserContactStatuses';

export default function ContactStatusPage() {
    /*
        TIP: request for page dependancies which should be resolved before 
        displaying page children
     */
    /* const statusRequest = useAppSelector((state) => {
        return state.statuses?.requestStatus || RequestStatus.none;
    }); */

    const {
        data: userStatuses,
        isLoading: isUserStatusesLoading,
        isError: isUserStatusesError,
    } = useUserContactStatuses();

    return (
        <PageMain
            pageTitle="Contact Status"
            showError={isUserStatusesError}
            showLoading={isUserStatusesLoading}
        >
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <ContactStatusSettings userStatuses={userStatuses || []} />
                </div>
            </div>
        </PageMain>
    );
}
